"use strict";
// Generated by bin/generate-model-map
// Try not to edit this file
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "reportcacheddata": {
        "requirePath": "../../resources/reports/reportbuild",
        "exportKey": "default",
        "resourceClassName": "ReportBuildResource"
    },
    "reportcachedparameters": {
        "requirePath": "../../resources/reports/reportparam",
        "exportKey": "default",
        "resourceClassName": "ReportParamResource"
    },
    "reportrender": {
        "requirePath": "../../resources/reports/reportrender",
        "exportKey": "default",
        "resourceClassName": "ReportRenderResource"
    },
    "account": {
        "requirePath": "../../resources/system/account",
        "exportKey": "default",
        "resourceClassName": "AccountResource"
    },
    "actualfeerate": {
        "requirePath": "../../resources/system/actualfeerate",
        "exportKey": "default",
        "resourceClassName": "ActualFeeRateResource"
    },
    "address": {
        "requirePath": "../../resources/system/address",
        "exportKey": "default",
        "resourceClassName": "AddressResource"
    },
    "agent": {
        "requirePath": "../../resources/system/agent",
        "exportKey": "default",
        "resourceClassName": "AgentResource"
    },
    "agreement": {
        "requirePath": "../../resources/system/agreement",
        "exportKey": "default",
        "resourceClassName": "AgreementResource"
    },
    "assignment": {
        "requirePath": "../../resources/system/assignment",
        "exportKey": "default",
        "resourceClassName": "AssignmentResource"
    },
    "backgroundtaskstatus": {
        "requirePath": "../../resources/system/backgroundtaskstatus",
        "exportKey": "default",
        "resourceClassName": "BackgroundTaskStatusResource"
    },
    "bank": {
        "requirePath": "../../resources/system/bank",
        "exportKey": "default",
        "resourceClassName": "BankResource"
    },
    "bankrec": {
        "requirePath": "../../resources/system/bankrec",
        "exportKey": "default",
        "resourceClassName": "BankRecResource"
    },
    "budget": {
        "requirePath": "../../resources/system/budget",
        "exportKey": "default",
        "resourceClassName": "BudgetResource"
    },
    "city": {
        "requirePath": "../../resources/system/city",
        "exportKey": "default",
        "resourceClassName": "CityResource"
    },
    "company": {
        "requirePath": "../../resources/system/company",
        "exportKey": "default",
        "resourceClassName": "CompanyResource"
    },
    "country": {
        "requirePath": "../../resources/system/country",
        "exportKey": "default",
        "resourceClassName": "CountryResource"
    },
    "countrytaxcode": {
        "requirePath": "../../resources/system/countrytaxcode",
        "exportKey": "default",
        "resourceClassName": "CountryTaxCodeResource"
    },
    "currency": {
        "requirePath": "../../resources/system/currency",
        "exportKey": "default",
        "resourceClassName": "CurrencyResource"
    },
    "department": {
        "requirePath": "../../resources/system/department",
        "exportKey": "default",
        "resourceClassName": "DepartmentResource"
    },
    "depositaccount": {
        "requirePath": "../../resources/system/depositaccount",
        "exportKey": "default",
        "resourceClassName": "DepositAccountResource"
    },
    "eeoclass": {
        "requirePath": "../../resources/system/eeoclass",
        "exportKey": "default",
        "resourceClassName": "EEOClassResource"
    },
    "employee": {
        "requirePath": "../../resources/system/employee",
        "exportKey": "default",
        "resourceClassName": "EmployeeResource"
    },
    "employeedirectdepositrule": {
        "requirePath": "../../resources/system/employeedirectdepositrule",
        "exportKey": "default",
        "resourceClassName": "EmployeeDirectDepositRuleResource"
    },
    "employeetype": {
        "requirePath": "../../resources/system/employeetype",
        "exportKey": "default",
        "resourceClassName": "EmployeeTypeResource"
    },
    "episode": {
        "requirePath": "../../resources/system/episode",
        "exportKey": "default",
        "resourceClassName": "EpisodeResource"
    },
    "fee": {
        "requirePath": "../../resources/system/fee",
        "exportKey": "default",
        "resourceClassName": "FeeResource"
    },
    "feecategory": {
        "requirePath": "../../resources/system/feecategory",
        "exportKey": "default",
        "resourceClassName": "FeeCategoryResource"
    },
    "feegroup": {
        "requirePath": "../../resources/system/feegroup",
        "exportKey": "default",
        "resourceClassName": "FeeGroupResource"
    },
    "file": {
        "requirePath": "../../resources/system/file",
        "exportKey": "default",
        "resourceClassName": "FileResource"
    },
    "flsatype": {
        "requirePath": "../../resources/system/flsatype",
        "exportKey": "default",
        "resourceClassName": "FLSATypeResource"
    },
    "freefield": {
        "requirePath": "../../resources/system/freefield",
        "exportKey": "default",
        "resourceClassName": "FreeFieldResource"
    },
    "group": {
        "requirePath": "../../resources/system/group",
        "exportKey": "default",
        "resourceClassName": "GroupResource"
    },
    "industry": {
        "requirePath": "../../resources/system/industry",
        "exportKey": "default",
        "resourceClassName": "IndustryResource"
    },
    "insurance": {
        "requirePath": "../../resources/system/insurance",
        "exportKey": "default",
        "resourceClassName": "InsuranceResource"
    },
    "laborunion": {
        "requirePath": "../../resources/system/laborunion",
        "exportKey": "default",
        "resourceClassName": "LaborUnionResource"
    },
    "laborunionlocal": {
        "requirePath": "../../resources/system/laborunionlocal",
        "exportKey": "default",
        "resourceClassName": "LaborUnionLocalResource"
    },
    "legislativetype": {
        "requirePath": "../../resources/system/legislativetype",
        "exportKey": "default",
        "resourceClassName": "LegislativeTypeResource"
    },
    "loanout": {
        "requirePath": "../../resources/system/loanout",
        "exportKey": "default",
        "resourceClassName": "LoanoutResource"
    },
    "location": {
        "requirePath": "../../resources/system/location",
        "exportKey": "default",
        "resourceClassName": "LocationResource"
    },
    "occcode": {
        "requirePath": "../../resources/system/occcode",
        "exportKey": "default",
        "resourceClassName": "OCCCodeResource"
    },
    "paycode": {
        "requirePath": "../../resources/system/paycode",
        "exportKey": "default",
        "resourceClassName": "PayCodeResource"
    },
    "paycodetype": {
        "requirePath": "../../resources/system/paycodetype",
        "exportKey": "default",
        "resourceClassName": "PayCodeTypeResource"
    },
    "period": {
        "requirePath": "../../resources/system/period",
        "exportKey": "default",
        "resourceClassName": "PeriodResource"
    },
    "permission": {
        "requirePath": "../../resources/system/permission",
        "exportKey": "default",
        "resourceClassName": "PermissionResource"
    },
    "production": {
        "requirePath": "../../resources/system/production",
        "exportKey": "default",
        "resourceClassName": "ProductionResource"
    },
    "productiontype": {
        "requirePath": "../../resources/system/productiontype",
        "exportKey": "default",
        "resourceClassName": "ProductionTypeResource"
    },
    "project": {
        "requirePath": "../../resources/system/project",
        "exportKey": "default",
        "resourceClassName": "ProjectResource"
    },
    "projectfeeaccumulationgroup": {
        "requirePath": "../../resources/system/projectfeeaccumulationgroup",
        "exportKey": "default",
        "resourceClassName": "ProjectFeeAccumulationGroupResource"
    },
    "schedule": {
        "requirePath": "../../resources/system/schedule",
        "exportKey": "default",
        "resourceClassName": "ScheduleResource"
    },
    "series": {
        "requirePath": "../../resources/system/series",
        "exportKey": "default",
        "resourceClassName": "SeriesResource"
    },
    "set": {
        "requirePath": "../../resources/system/set",
        "exportKey": "default",
        "resourceClassName": "SetResource"
    },
    "appsetting": {
        "requirePath": "../../resources/system/settings",
        "exportKey": "default",
        "resourceClassName": "APISettingResource"
    },
    "state": {
        "requirePath": "../../resources/system/state",
        "exportKey": "default",
        "resourceClassName": "StateResource"
    },
    "title": {
        "requirePath": "../../resources/system/title",
        "exportKey": "default",
        "resourceClassName": "TitleResource"
    },
    "usersourcecode": {
        "requirePath": "../../resources/system/usersourcecode",
        "exportKey": "default",
        "resourceClassName": "UserSourceCodeResource"
    },
    "budgetline": {
        "requirePath": "../../resources/system/variance",
        "exportKey": "default",
        "resourceClassName": "VarianceResource"
    },
    "vendor": {
        "requirePath": "../../resources/system/vendor",
        "exportKey": "default",
        "resourceClassName": "VendorResource"
    },
    "formw9": {
        "requirePath": "../../resources/system/w9",
        "exportKey": "default",
        "resourceClassName": "W9Resource"
    },
    "wcclassification": {
        "requirePath": "../../resources/system/wcclassification",
        "exportKey": "default",
        "resourceClassName": "WCClassificationResource"
    },
    "wccode": {
        "requirePath": "../../resources/system/wccode",
        "exportKey": "default",
        "resourceClassName": "WCCodeResource"
    },
    "accountspayable": {
        "requirePath": "../../resources/transactions/ap/index",
        "exportKey": "default",
        "resourceClassName": "AccountsPayableResource"
    },
    "accountspayableline": {
        "requirePath": "../../resources/transactions/ap/lines",
        "exportKey": "default",
        "resourceClassName": "AccountsPayableLineResource"
    },
    "accountsreceivable": {
        "requirePath": "../../resources/transactions/ar/index",
        "exportKey": "default",
        "resourceClassName": "AccountsReceivableResource"
    },
    "accountsreceivableline": {
        "requirePath": "../../resources/transactions/ar/lines",
        "exportKey": "default",
        "resourceClassName": "AccountsReceivableLineResource"
    },
    "batch": {
        "requirePath": "../../resources/transactions/batch",
        "exportKey": "default",
        "resourceClassName": "BatchResource"
    },
    "billableitem": {
        "requirePath": "../../resources/transactions/billableitem",
        "exportKey": "default",
        "resourceClassName": "BillableItemResource"
    },
    "billabletype": {
        "requirePath": "../../resources/transactions/billabletype",
        "exportKey": "default",
        "resourceClassName": "BillableTypeResource"
    },
    "billpayment": {
        "requirePath": "../../resources/transactions/bp/index",
        "exportKey": "default",
        "resourceClassName": "BillPaymentResource"
    },
    "billpaymentline": {
        "requirePath": "../../resources/transactions/bp/lines",
        "exportKey": "default",
        "resourceClassName": "BillPaymentLineResource"
    },
    "papercheck": {
        "requirePath": "../../resources/transactions/check/index",
        "exportKey": "default",
        "resourceClassName": "CheckResource"
    },
    "checkrun": {
        "requirePath": "../../resources/transactions/checkrun",
        "exportKey": "default",
        "resourceClassName": "CheckRunResource"
    },
    "customer": {
        "requirePath": "../../resources/transactions/customer",
        "exportKey": "default",
        "resourceClassName": "CustomerResource"
    },
    "transactionexport": {
        "requirePath": "../../resources/transactions/exports",
        "exportKey": "default",
        "resourceClassName": "TransactionExportResource"
    },
    "journalentry": {
        "requirePath": "../../resources/transactions/je/index",
        "exportKey": "default",
        "resourceClassName": "JournalEntryResource"
    },
    "journalentryline": {
        "requirePath": "../../resources/transactions/je/lines",
        "exportKey": "default",
        "resourceClassName": "JournalEntryLineResource"
    },
    "ledgeritem": {
        "requirePath": "../../resources/transactions/ledgeritem",
        "exportKey": "default",
        "resourceClassName": "LedgerItemResource"
    },
    "markup": {
        "requirePath": "../../resources/transactions/markup",
        "exportKey": "default",
        "resourceClassName": "MarkupResource"
    },
    "pettycash": {
        "requirePath": "../../resources/transactions/pc/index",
        "exportKey": "default",
        "resourceClassName": "PettyCashResource"
    },
    "pettycashline": {
        "requirePath": "../../resources/transactions/pc/lines",
        "exportKey": "default",
        "resourceClassName": "PettyCashLineResource"
    },
    "purchaseorder": {
        "requirePath": "../../resources/transactions/po/index",
        "exportKey": "default",
        "resourceClassName": "PurchaseOrderResource"
    },
    "purchaseorderline": {
        "requirePath": "../../resources/transactions/po/lines",
        "exportKey": "default",
        "resourceClassName": "PurchaseOrderLineResource"
    },
    "prepayment": {
        "requirePath": "../../resources/transactions/pp/index",
        "exportKey": "default",
        "resourceClassName": "PrePaymentResource"
    },
    "prepaymentline": {
        "requirePath": "../../resources/transactions/pp/lines",
        "exportKey": "default",
        "resourceClassName": "PrePaymentLineResource"
    },
    "payroll": {
        "requirePath": "../../resources/transactions/pr/index",
        "exportKey": "default",
        "resourceClassName": "PayrollResource"
    },
    "payrollline": {
        "requirePath": "../../resources/transactions/pr/lines",
        "exportKey": "default",
        "resourceClassName": "PayrollLineResource"
    },
    "payrollcomment": {
        "requirePath": "../../resources/transactions/pr/payrollcomment",
        "exportKey": "default",
        "resourceClassName": "PayrollCommentResource"
    },
    "payrolldetailline": {
        "requirePath": "../../resources/transactions/pr/payrolldetailline",
        "exportKey": "default",
        "resourceClassName": "PayrollDetailLineResource"
    },
    "salesrep": {
        "requirePath": "../../resources/transactions/salesrep",
        "exportKey": "default",
        "resourceClassName": "SalesRepResource"
    },
    "user": {
        "requirePath": "../../resources/user/index",
        "exportKey": "default",
        "resourceClassName": "UserResource"
    }
};
//# sourceMappingURL=model-relationships.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/util/resources/model-relationships.js
// module id = V06x
// module chunks = 0